import styled from "styled-components";
import { media } from "../../theme/theme";
import { MarketingLinkHoverEffect } from "../ReusableStyledComponents/MarketingLinkHover";
import { MarketingSpacing } from "../ReusableStyledComponents/MarketingSpacing";
import { MediumText, Body, H4 } from "../Typography";

export const MarketingCenteredTextWrapper = styled.div`
    position: relative;
    ${MarketingSpacing}
`;

export const MarketingCenteredTextContainer = styled.div`
    max-width: 606px;
    margin: 0 auto;

    ${MediumText} {
        margin-bottom: 8px;

        ${media.tablet} {
            margin-bottom: 16px;
        }
    }

    ${Body} {
        color:  ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
        margin-bottom: 25px;

        ${media.tablet} {
            margin-bottom: 35px;
        }

        p {
            &:not(:last-child) {
                margin-bottom: 15px;
            }
        }
    }

    ${H4} {
        color:  ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};
    }
`;

export const DesktopIconWrapper = styled.div<{ iconPosition: "left" | "right" }>`
    position: absolute;
    padding: 0 16px;
    top: 60px;
    max-width: 1290px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    display: none;

    ${media.custom(1080)} {
        display: block;
    }

    > img {
        display: block;
        margin-left: ${({ iconPosition }) => iconPosition === "left" ? null : "auto"};
    }
`;

export const PunchlineWrapper = styled.div`
    display: flex;
    margin-bottom: 24px;
    justify-content: space-between;

    > div {
        &:nth-child(2) {
            display: block;
            margin-top: 8px;
            margin-left: 16px;

            ${media.phone} {
                display: none;
            }
        }
    }
`;

export const CenteredTextLinkWrapper = styled.div`
    ${MarketingLinkHoverEffect}
    
    a {
        &:hover {
            ${H4} {
                color:  ${({ theme }) => theme ? theme.marketing.colors.chathamsBlue : null};
            }
        }

        > div {
            display: flex;
            align-items: center;

            > div {
                &:first-child {
                    margin-right: 7px;
                }
            }
        }
    }
`;